<template>
	<main>
		<div class="wrap">
			<h6>상승률 상위 업종&테마</h6>
			<section v-if="!isBannerLoading && (getBannerMulti?.rise_rate?.length ?? 0) > 0" class="c_responsive">
				<SubSwiperSlide :data="getBannerMulti?.rise_rate ?? []" />
			</section>
			<section>
				<HomeItemLayout>
					<StickyTabBar :items="tabItems" :tab-pk="1"></StickyTabBar>
					<div class="ly_col-16">
						<RoundCategoryList
							:data="sectorThemeData?.sector_theme.slice(0, moreNumber) ?? []"
							:sort="route.query.tab1 ? String(route.query.tab1) : '업종'"
						/>
						<ResponsiveLayout>
							<MoreButton
								v-if="tab === '테마' && moreNumber < (sectorThemeData?.sector_theme.length ?? 0)"
								@click="getMoreItem"
							/>
						</ResponsiveLayout>
					</div>
				</HomeItemLayout>
			</section>

			<section class="section_rising">
				<ExpandableTitleBar class="c_responsive" title="지금 뜨고 있는 업종&테마" :has-view="false" />
				<div class="rising_content">
					<StickyTabBar :items="tabItems" :tab-pk="2" :style="{ marginBottom: '3.2rem' }"></StickyTabBar>
					<CategoryBar
						:items="categoryItems"
						:sort="route.query.tab2 ? String(route.query.tab2) : '업종'"
						:query-key="2"
						:style="{ marginBottom: '3.2rem' }"
					/>
					<ListLayout class="c_responsive">
						<TopGainingList
							v-for="(item, idx) in riseSectorThemeData?.rise_sector_theme"
							:key="idx"
							:data="item"
							:idx="idx + 1"
							:sort="route.query.tab2 ? String(route.query.tab2) : '업종'"
						/>
					</ListLayout>
				</div>
			</section>
		</div>
	</main>
</template>

<script setup lang="ts">
// core
import { computed, onBeforeMount, onMounted, ref } from 'vue';
// lib
import { useRoute } from 'vue-router';

import { useGetCheckAuthApi } from '@/api/auth';
// api
import { useGetBannerMultiApi } from '@/api/banner';
import { useGetRiseSectorThemeApi, useGetSectorThemeApi } from '@/api/topGaining';
import MoreButton from '@/components/atom/button/MoreButton.vue';
import CategoryBar from '@/components/atom/tabBar/CategoryBar.vue';
// component
import ExpandableTitleBar from '@/components/atom/tabBar/ExpandableTitleBar.vue';
import StickyTabBar from '@/components/atom/tabBar/StickyTabBar.vue';
import HomeItemLayout from '@/components/home/HomeItemLayout.vue';
import ListLayout from '@/components/layout/main/ListLayout.vue';
import ResponsiveLayout from '@/components/layout/main/ResponsiveLayout.vue';
import RoundCategoryList from '@/components/rankList/RoundCategoryList.vue';
import TopGainingList from '@/components/rankList/TopGainingList.vue';
import SubSwiperSlide from '@/components/swiper/SubSwiperSlide.vue';
// store
import { useDisplayStore } from '@/stores/display';
import { handleChangeTopGainingCategory } from '@/utils/function/convertValue';
import { useModalStore } from '@/stores/modal';

// -----variable-----
const tabItems = ['업종', '테마'];
const categoryItems = ['주간', '월간', '분기', '연간'];

const displayStore = useDisplayStore();
const route = useRoute();
const modalStore = useModalStore();

const moreNumber = ref();

const selectedCategory = computed(() => (route.query.sort2 ? String(route.query.sort2) : '주간'));

const tab = computed(() => route.query.tab1 ?? '업종');
const selectedTopGainingTab = computed(() => route.query.tab2 ?? '업종');
// -----api-----
const { refetch: refetchCheckAuth } = useGetCheckAuthApi(
	computed(() => ({
		num: 'ALL',
		student: false,
		enable: false,
	}))
);
const { data: getBannerMulti, isLoading: isBannerLoading } = useGetBannerMultiApi({ type: 'rise_rate' });
const { data: sectorThemeData } = useGetSectorThemeApi(
	computed(() => ({
		category: tab.value === '업종' ? 'sector' : 'theme',
	}))
);
const { data: riseSectorThemeData } = useGetRiseSectorThemeApi(
	computed(() => ({
		home_yn: 0,
		category: selectedTopGainingTab.value === '업종' ? 'sector' : 'theme',
		period: handleChangeTopGainingCategory(selectedCategory.value),
	}))
);
// -----function-----
// 더보기 클릭 시 실행 함수
const getMoreItem = () => {
	if (moreNumber.value < ((sectorThemeData.value && sectorThemeData.value.sector_theme.length) ?? 0)) {
		if (displayStore.isDesktop) {
			moreNumber.value = moreNumber.value + 12;
		} else {
			moreNumber.value = moreNumber.value + 9;
		}
	} else {
		if (displayStore.isDesktop) {
			moreNumber.value = moreNumber.value - 12;
		} else {
			moreNumber.value = moreNumber.value - 9;
		}
	}
};

onMounted(() => {
	moreNumber.value = 12;

	// const options = {
	// 	root: null,
	// 	rootMargin: '0px',
	// 	threshold: 1.0,
	// };

	// const observer = new IntersectionObserver(function (entries, observer) {
	// 	entries.forEach((entry) => {
	// 		// top 값을 직접 출력해서 확인
	// 		console.log('Current top value:', entry.boundingClientRect.top);

	// 		if (entry.boundingClientRect.top <= 0) {
	// 			console.log('Element reached top:', {
	// 				isIntersecting: entry.isIntersecting,
	// 				top: entry.boundingClientRect.top,
	// 				target: entry.target,
	// 			});
	// 		}
	// 	});
	// }, options);
});

onBeforeMount(async () => {
	const res = await refetchCheckAuth();
	if (!res.data?.success) {
		modalStore.openModal('GuideModal');
	}
});
</script>

<style scoped lang="scss">
.wrap {
	display: flex;
	flex-direction: column;
	gap: 4.8rem;
	width: 100%;
	max-width: 68rem;
	padding-top: var(--header-height);
	margin: 7.2rem auto 8.8rem;
	@media screen and (max-width: 1280px) {
		margin: 4rem auto 8rem;
	}
	.report_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-bold);
		line-height: 2.387rem;
	}
	.report_title_sub {
		color: var(--color-base-light, #c6c6d6);
		font-size: var(--font-s-mid);
		font-weight: var(--font-w-light);
		line-height: 1.9rem;
	}
}

.section_rising {
	display: flex;
	flex-direction: column;
	gap: 2rem;
}
</style>
